import { Component, Input, EventEmitter, Output } from '@angular/core';
import {
  ModalButtons,
  DialogResult,
  Button,
  ModalButtonAndText
} from './modal-button';

@Component({
  selector: 'ct-modal-container',
  templateUrl: './modal-container.component.html'
})
export class ModalContainerComponent {
  @Output()
  buttonClick = new EventEmitter<any>();

  @Input()
  public title: string;

  @Input()
  public message: string;

  @Input()
  public showCloseButton = true;

  private buttonText = [];

  @Input()
  public set buttons(value: ModalButtons[] | ModalButtons) {
    this.buttonText = [];
    if (value) {
      this.normalizeButton(value).forEach(btn => {
        this.buttonText.push(ModalButtonAndText[btn.toString()]);
      });
    }
  }

  public closeButtonClicked() {
    this.buttonClick.emit(DialogResult.close);
  }

  public buttonClicked(button: Button) {
    this.buttonClick.emit(button.dialogResult);
  }

  private normalizeButton(
    value: ModalButtons[] | ModalButtons
  ): ModalButtons[] {
    const buttons = Array.isArray(value) ? value : [value];
    const finalButtons: ModalButtons[] = [];
    buttons.forEach(btn => {
      switch (btn) {
        case ModalButtons.none:
          break;
        case ModalButtons.abortRetryIgnore:
          finalButtons.push(ModalButtons.abort);
          finalButtons.push(ModalButtons.retry);
          finalButtons.push(ModalButtons.ignore);
          break;
        case ModalButtons.dangerYesNo:
          finalButtons.push(ModalButtons.dangerYes);
          finalButtons.push(ModalButtons.no);
          break;
        case ModalButtons.okCancel:
          finalButtons.push(ModalButtons.ok);
          finalButtons.push(ModalButtons.cancel);
          break;
        case ModalButtons.retryCancel:
          finalButtons.push(ModalButtons.retry);
          finalButtons.push(ModalButtons.cancel);
          break;
        case ModalButtons.saveCancel:
          finalButtons.push(ModalButtons.save);
          finalButtons.push(ModalButtons.cancel);
          break;
        case ModalButtons.yesNo:
          finalButtons.push(ModalButtons.yes);
          finalButtons.push(ModalButtons.no);
          break;
        case ModalButtons.yesNoCancel:
          finalButtons.push(ModalButtons.yes);
          finalButtons.push(ModalButtons.no);
          finalButtons.push(ModalButtons.cancel);
          break;
        default:
          finalButtons.push(btn);
          break;
      }
    });

    return finalButtons;
  }

  public getButtons() {
    return this.buttonText;
  }
}
